import { Component, inject, OnInit, signal } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AuthService, TLoginState } from '../services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/message';
import { AppleLoginService, TAppleLoginState } from '../services/apple-login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [TranslatePipe, Message],
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  public translate = inject(TranslateService);
  public translationPrefix = 'login.';
  public loginFlowState = signal<TLoginState>('NOT_STARTED');
  public appleLoginFlowState = signal<TAppleLoginState>('NOT_STARTED');  
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private appleLoginService = inject(AppleLoginService);

  public hasError = signal<boolean>(false);

  ngOnInit() {
    const nav = this.router.getCurrentNavigation();

    const navState = (nav?.extras?.state ?? history.state) as {error?:string; source?:string};
    if (navState?.error === 'login-failed' && navState.source === 'apple-id-login') {
      this.hasError.set(true);
      this.appleLoginFlowState.set("ERROR");
    }
    
    if (this.activatedRoute.snapshot.queryParams['unauthorized']) {
      this.hasError.set(true);
      this.loginFlowState.set('UNAUTHORIZED');
    }
  }

  public async startLoginFlow() {
    this.loginFlowState.set('IN_PROGRESS');
    this.appleLoginFlowState.set('DISABLED');
    this.hasError.set(false);
    const loginFlowRes: TLoginState = await this.authService.startLoginFlow();
    this.loginFlowState.set(loginFlowRes);
    if (loginFlowRes === 'SUCCESS') {
      this.router.navigate(['/app/import']);
      this.appleLoginFlowState.set('NOT_STARTED');
    } else {
      this.hasError.set(true);
      this.appleLoginFlowState.set('NOT_STARTED');
    }
  }

  public async appleIdLoginFlow() {
    this.loginFlowState.set('DISABLED');
    this.appleLoginFlowState.set('IN_PROGRESS');
    this.hasError.set(false);
    const appleLoginFlowResult: TAppleLoginState = await this.appleLoginService.appleLogin();
    this.appleLoginFlowState.set(appleLoginFlowResult);
    if (appleLoginFlowResult === 'SUCCESS') {
      this.router.navigate(['/app/import']);
      this.loginFlowState.set('NOT_STARTED');
    } else {
      this.hasError.set(true);
      this.loginFlowState.set('NOT_STARTED');
    }
  }

}
